export type NumericValueKind =
  | "instrument-price"
  | "point-change"
  | "percentage-change"
  | "econ-actual"
  | "count"
  | "score"
  | "duration"
  | "date-time"
  | "metric";

export interface NumericMotionPolicyInput {
  kind?: NumericValueKind;
  updateIntervalMs?: number | null;
  surface?: string;
  forceStatic?: boolean;
}

export function shouldAnimateNumericValue({
  kind = "metric",
  updateIntervalMs,
  surface,
  forceStatic = false,
}: NumericMotionPolicyInput): boolean {
  if (forceStatic) return false;
  if (kind === "instrument-price") return false;
  if (updateIntervalMs != null && updateIntervalMs < 2_000) return false;
  if (kind === "econ-actual" && surface === "econ-countdown-drawer") {
    return false;
  }
  return true;
}
